export default "__VITE_ASSET__YsYHKwrr__"